var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1753 11.4363C20.1672 9.35884 19.5006 6.93693 17.7063 5.60753C18.015 4.95475 17.7278 4.17943 17.0627 3.87379C16.3982 3.56816 15.6068 3.84793 15.2933 4.49868C13.1044 3.997 10.7816 5.04459 9.79042 7.12276C9.79042 7.12276 8.13484 10.6195 7.71245 11.4942C7.29005 12.3689 6.82812 12.8304 6.19072 12.6874C5.43748 12.5193 4.78621 12.6636 4.48589 13.2933C4.18557 13.9222 4.46162 14.6717 5.10318 14.9664L10.4244 17.4128L10.7143 17.5463L16.0355 19.9927C16.6763 20.2874 17.44 20.0165 17.7403 19.3869C18.0406 18.7579 17.562 18.1003 17.123 17.7137C16.7145 17.3536 16.65 16.7342 17.1681 15.6607C17.6862 14.588 19.1746 11.437 19.1746 11.437L19.1753 11.4363Z",
    fill: "url(#paint0_linear_468_75838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6561 19.4464C12.8121 18.8391 13.2568 17.4101 12.6494 16.2546C12.0419 15.099 10.6124 14.6544 9.45637 15.2616C8.30035 15.8688 7.85564 17.2979 8.46308 18.4534C9.07051 19.609 10.5001 20.0536 11.6561 19.4464Z",
    fill: "url(#paint1_linear_468_75838)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5529 19.8087C10.2043 19.8087 9.85016 19.7344 9.51463 19.577C8.92058 19.2987 8.47023 18.8059 8.24678 18.1894C8.02332 17.5729 8.05357 16.9055 8.33203 16.3117C8.90683 15.0855 10.372 14.5549 11.5986 15.1295C12.8252 15.7041 13.356 17.1687 12.7812 18.3956C12.3639 19.2863 11.4769 19.8094 10.5529 19.8094V19.8087ZM10.5604 15.0814C9.70509 15.0814 8.88483 15.566 8.49843 16.3893C8.24059 16.9392 8.21309 17.5557 8.41935 18.1262C8.62631 18.6966 9.04228 19.153 9.59233 19.41C10.7275 19.9413 12.0827 19.4506 12.6148 18.3165C13.1463 17.1818 12.6554 15.8264 11.5209 15.2952C11.2102 15.1495 10.8829 15.0807 10.5604 15.0807V15.0814Z",
    fill: "url(#paint2_linear_468_75838)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75838",
    x1: 8.26177,
    y1: 4.07868,
    x2: 16.4116,
    y2: 20.0667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA70F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75838",
    x1: 8.46313,
    y1: 18.4535,
    x2: 12.6487,
    y2: 16.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75838",
    x1: 8.09869,
    y1: 17.3536,
    x2: 13.0131,
    y2: 17.3536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorNotification);
export default __webpack_public_path__ + "static/media/color-notification.7b1ee902e508d3b47274581da98d0493.svg";
export { ForwardRef as ReactComponent };